const rgbaWithAlpha = /^((?:rgba?)\([\d.]*,\s[\d.]*,\s[\d.]*),\s([\d.]*)\)/;

export const makeAlphaColor = (originalRGBAColor: string, alpha: string) => {
  if (rgbaWithAlpha.test(originalRGBAColor)) {
    return originalRGBAColor.replace(rgbaWithAlpha, `$1, ${alpha})`);
  }
  return originalRGBAColor.replace(")", `, ${alpha})`);
};

export const CustomColors = {
  coWorkerYellow: "#FFCD3F",
  coWorkerBlue: "#151E44",

  taskOther: "rgb(146, 146, 146)",

  taskTask: "rgb(135, 99, 184)",
  taskRole: "rgb(229, 47, 126)",

  taskPnP: "rgb(255,203,192)",

  outlookBlue: "rgb(0, 88, 163)",

  planningAppointment: "rgb(238, 127, 0)",
  verificationAppointment: "rgb(255, 219, 0)",
  orderAppointment: "rgb(122, 181, 29)",
  walkInAppointment: "rgb(0, 102, 88)",
};

export const zIndex = {
  modalSheet: 201,
  popover: 201,
  header: 100,
  banner: 100,
  tab: 99,
  datepicker: 200,
  searchField: 5,
  searchDropdown: 4,
  filterDropdown: 4,
  backdrop: 2,
};

export const pixels = {
  radius10: "10px",
  space10: "10px",
  space8: "8px",
  space4: "4px",
  headerHeight: "80px",
  avatarHeight: "48px",
  avatarHeightSmall: "15px",
  gridGap: "5px",
  calendarLabelWidth: "140px",
  colorLine: "5px",
  outline: "5px",
};
